var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,7.3732L12.9035,7.3732A3,3 0,0 1,15.9035 10.3732L15.9035,18.2247A3,3 0,0 1,12.9035 21.2247L3,21.2247A3,3 0,0 1,0 18.2247L0,10.3732A3,3 0,0 1,3 7.3732z",
    fill: "#28AEB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5168,15.8775V6.1302C10.5168,3.2969 12.8136,1 15.6469,1V1C18.4802,1 20.7771,3.2969 20.7771,6.1302V8.4388",
    fill: "none",
    stroke: "#28AEB1",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.46651d2494fea7d9b8eb6d203c496a69.svg";
export { ForwardRef as ReactComponent };